import { useCurrentBranding } from '@/hooks/use-current-branding';
import PigelloLogo from '@/public/assets/logo/pigello_blue_text.svg';
import Image from 'next/image';

export function SessionLoader({
  isVisible,
  disableAnimation = false,
}: {
  isVisible: boolean;
  disableAnimation?: boolean;
}) {
  const [branding] = useCurrentBranding();
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-background transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div
        className={`${disableAnimation ? '' : 'animate-bounce-gentle transition-all duration-500'} ${
          isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* Replace this with your actual logo */}
        <div className='flex items-center justify-center'>
          <Image
            width={100}
            height={28}
            src={
              branding?.branding?.images?.logo?.signed_url_get ??
              PigelloLogo.src
            }
            alt='Logo'
            className='h-7 object-contain'
          />
        </div>
      </div>
    </div>
  );
}
